import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { TransientReservation } from '../models/reservation';
import { TransientReservationService } from './transient-reservation-http-service';
import { TransientReservationSearchParameters } from '../models/transient-reservation-search-params';
import { catchError, take } from 'rxjs/operators';
import { Page } from '../../shared/models/page';
import { LogService } from '../../shared/log/log.service';

@Injectable()
export class TransientReservationStore {

  private searchResultsPage: BehaviorSubject<Page<TransientReservation>> = new BehaviorSubject(Page.empty<TransientReservation>());

  private _selectedReservations = new Map<number, TransientReservation>();


  constructor(
    private flashMessagesService: FlashMessagesService,
    private transientReservationHttpService: TransientReservationService,
    private logService: LogService
  ) {}

  setTransientReservationPage(page: Page<TransientReservation>): void {
    this.searchResultsPage.next(page);
  }

  linkTransientReservationsToEvent(eventReservationIdList: number[], eventPartyId: number,
                                  doNotPay?: boolean) {
    return this.transientReservationHttpService.linkTransientReservationsToEvent(eventReservationIdList, eventPartyId, doNotPay)
      .pipe(
        take(1),
        catchError((error: any) => {
          this.flashMessagesService.error(
            'MESSAGES.ERROR.LINK_TRANSIENT_RESERVATION',
            `Error linking a transient reservation to an event: ${error}`
          );
          return Observable.throw(error);
        })
      );
  }

  searchTransientReservations(searchParameters: TransientReservationSearchParameters,
                                  page: number,
                                  size: number): Observable<Page<TransientReservation>> {
    this.logService.debug(`searchParameters: ${searchParameters}`);

    return this.transientReservationHttpService.search(searchParameters, page, size)
      .catch((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.SEARCH_TRANSIENT_RESERVATION',
          `Error retrieving transient reservations: ${error}`);
        return Observable.throw(error);
      })
      .map((res: Page<TransientReservation>) => {
        this.searchResultsPage.next(res);
        this.logService.debug(`searchResult: ${res}`);
        return res;
      });
  }

  get searchResults(): Observable<Page<TransientReservation>> {
    return this.searchResultsPage.asObservable();
  }

  get selectedReservations(): TransientReservation[] {
    return Array.from(this._selectedReservations.values());
  }

  clearSelectedReservations(): void {
    this._selectedReservations = new Map<number, TransientReservation>();
  }

  pushToSelectedReservations(transientReservation: TransientReservation) {
    this._selectedReservations.set(transientReservation.eventReservationId, transientReservation);
  }

  removeFromSelectedReservations(transientReservation: TransientReservation) {
    this._selectedReservations.delete(transientReservation.eventReservationId);
  }

  isReservationSelected(transientReservation: TransientReservation): boolean {
    return this._selectedReservations.has(transientReservation.eventReservationId);
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/transient-reservation-store.ts